<template>
  <div id="wt-footer">
    <div id="wt-footer-left">
      <p>
        DIGISYSTEM | <strong>{{tenant.tenant_name}}</strong> 
      </p>
    </div>

    <div id="wt-footer-center">
      <p>
        version:
        <strong>1.00.0000</strong>
      </p>
    </div>

    <div id="wt-footer-right">
      <p>{{localDate}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "wt-footer",
  components: {},
  props: {},
  computed: {
    tenant() {
      return this.$store.state.auth.tenant;
    }
  },
  data: function() {
    return {
      localDate: null
    };
  },
  methods: {
    init() {
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      options.timeZone = "UTC";
      options.timeZoneName = "short";
      this.localDate = new Date().toLocaleDateString("en-US", options);
    }
  },
  created() {
    this.init();
  }
};
</script>
<style>
</style>